module.exports = __webpack_public_path__ + "img/iot-gateway.55caa727.jpg";